import { type Translate } from 'next-translate';
import React, { useRef } from 'react';
import { LinkWithQuery } from '@/components/elements/LinkWithQuery';
import { MyImage } from '@/components/elements/MyImage';
import { AmplitudeService } from '@/services';
import { type LandingItem, type LandingTool } from '@/data/aiToolLandings';
import { AMPLITUDE_EVENTS } from '@/constants';
import { ScrollToTopButton } from '../ScrollToTopButton';
import styles from './FeatureGrid.module.scss';

interface FeatureGridProps {
	title: string;
	list: LandingItem[];
	t: Translate;
	className?: string;
	itemClassName?: string;
	activeFeature: LandingTool | null;
	activeTabId: string;
}
export const FeatureGrid = ({
	title,
	list,
	t,
	className,
	activeFeature,
	itemClassName,
	activeTabId,
}: FeatureGridProps) => {
	const gridWrapperRef = useRef<HTMLDivElement>(null);
	const gridItemRef = useRef<HTMLDivElement>(null);

	const handlePositioningItemClick = (positioningItem: LandingItem) => {
		if (!activeFeature) return;
		AmplitudeService.logEvent(AMPLITUDE_EVENTS.ALL_TOOLS_SUBFEATURE_SELECTED, {
			type: activeTabId,
			feature: t(activeFeature.title),
			subfeature: t(positioningItem.title),
		});
	};

	return (
		<div className={styles['feature-grid']} ref={gridWrapperRef}>
			<div className={className || ''}>
				{list.map(item => (
					<div
						ref={gridItemRef}
						key={item.id}
						data-id={item.id}
						role='button'
						tabIndex={0}
						onClick={() => handlePositioningItemClick(item)}
						onKeyDown={() => handlePositioningItemClick(item)}
					>
						<LinkWithQuery
							key={item.id}
							excludeParams={['category']}
							className={`${styles['image__item']} ${itemClassName}`}
							href={item.href}
						>
							<MyImage
								imageProps={{
									src: item.image,
									alt: '',
									title: t(title),
								}}
								settings={{
									classes: {
										picture: styles['image__item_picture'],
										image: styles['image__item_image'],
									},
								}}
							/>
							<p className={styles['image__item_title']}>{t(item.title)}</p>
						</LinkWithQuery>
					</div>
				))}
			</div>

			<ScrollToTopButton
				scrollableContainer={gridWrapperRef}
				itemRef={gridItemRef}
			/>
		</div>
	);
};
